import { Link, Outlet, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui';

export function AuthLayout() {
  const navigate = useNavigate();

  return (
    <div className="relative flex min-h-screen w-full flex-col bg-white">
      <div className="absolute left-0 top-4 z-50 flex w-full items-center justify-between px-4 md:top-8 md:px-8">
        <div className="flex items-center gap-4">
          <Button
            shape="icon"
            icon={ArrowLeft}
            variant="outline"
            size="sm"
            onClick={() => void navigate(-1)}
            aria-label="Go back"
          />
          <Link to="/" className="flex items-center heading-3">
            <span className="text-gray-900">Mondi</span>
            <span className="text-lime-500">vago</span>
          </Link>
        </div>
        <Link
          to="/supplier/login"
          className="text-sm font-semibold text-lime-200 transition-colors bg-lime-800 backdrop-blur-md px-4 py-2 rounded-full"
        >
          Partner Portal
        </Link>
      </div>
      <main className="flex w-full flex-1 flex-col">
        <Outlet />
      </main>
    </div>
  );
}
